import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import Timeline from '../Timeline';

function UserTimeLinePage(): ReactElement {
  const { userId } = useParams<{ userId: string }>();
  return (
    <div>
      <Timeline userId={userId} />
    </div>
  );
}

export default UserTimeLinePage;
